import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";
import { useData } from "@hooks/useData";
import { equalInLC } from "@datassential/platform-ui-lib";
import { ALL_CATEGORIES_TITLE } from "@pages/Home/components/HomeLnrCategory";
import { useCallback, useRef } from "react";

const method: keyof typeof apiConfig = 'get home category reports summary';
type Response = components["schemas"]["PublicationsWithAnswerBlock"];

const DEFAULT_DATA: Response = {
    items: [],
    answer: '',
};

export function useHomeCategoryReportsSummary(categoryName: string) {
    const requestRef = useRef<any>(null);

    const fetchFn = useCallback(
        async (name: string): Promise<Response> => {
            if (requestRef.current) requestRef.current.abort();

            const isGeneralCategory = equalInLC(name, ALL_CATEGORIES_TITLE) || !name.trim();
            const query = isGeneralCategory
                ? 'Food & Beverage trends'
                : name
            ;

            try {
                requestRef.current = http.getXHR(method, { query });
                // an empty response body resolves to null, which the consumer
                // destructures in its render body — contain it here.
                return (await requestRef.current as Response | null) ?? DEFAULT_DATA;
            } catch {
                return DEFAULT_DATA;
            }
        },
        []
    );

    return useData(DEFAULT_DATA, fetchFn, categoryName);
}
